module.exports = __webpack_public_path__ + "img/t4s.e3f76c86.svg";